.body {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
}

.changed {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  font-size: var(--tuna-typography-body2-fontSize);
}
